import { useNavigate } from "react-router-dom";
import DiscordIcon from "../../icon/DiscordIcon";
import HelpIcon from "../../icon/HelpIcon";
import LogoutIcon from "../../icon/LogoutIcon";
import classes from "./Header.module.css";
import CloseIcon from "../../icon/CloseIcon";
import { useUser } from "../../context/UserContext";
import SparklesIcon from "../../icon/SparklesIcon";
import useWindowDimensions from "../../hooks/getWindowDimensions";
import { IoMdClose } from "react-icons/io";
import { AiOutlineMenu } from "react-icons/ai"; // Menu icon
import { useState } from "react";
import { env } from "../../constants/env";

const Header = ({ faq }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { height, width } = useWindowDimensions();
  const { logout } = useUser();
  // Close menu when clicking outside
  const closeMenu = (e) => {
    if (e.target.classList.contains(classes.menuOverlay)) {
      setMenuOpen(false);
    }
  };
  return (
    <>
      <div
        className={`${classes.wrapper} d-flex justify-content-between align-items-center`}
      >
        <img
          src="/PROPTRADING.FUN-LOGO.svg"
          alt="logo"
          onClick={() => navigate("/")}
          role="button"
        />
        {faq ? (
          <CloseIcon onClick={() => navigate("/")} />
        ) : (
          <div className="d-flex align-items-center gap-3">
            {/* <button
              className={`d-flex gap-1 ${classes.referButton}`}
              onClick={() => navigate("/refer")}
            >
              <SparklesIcon />
              Refer
            </button>{" "} */}
            {width > 768 ? (
              <>
                <a href="https://docs.proptrading.fun/" target="_blank">
                  <button>Docs</button>
                </a>
                <div className="d-flex align-items-center gap-2">
                  <HelpIcon onClick={() => navigate("/faq")} />
                  <DiscordIcon />
                  <LogoutIcon onClick={logout} />
                </div>
              </>
            ) : (
              <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? (
                  <IoMdClose size={24} />
                ) : (
                  <div className={classes.twoBarMenu}></div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      {/* Full-screen overlay (visible when menu is open) */}
      {menuOpen && (
        <div className={classes.menuOverlay} onClick={closeMenu}>
          <div
            className={`d-flex justify-content-between align-items-center w-100 ${classes.mobileHeader}`}
          >
            <img
              src="/PROPTRADING.FUN-LOGO.svg"
              alt="logo"
              onClick={() => navigate("/")}
              role="button"
            />
            <div className="menu-icon" onClick={() => setMenuOpen(false)}>
              <IoMdClose size={24} />{" "}
            </div>
          </div>
          <div className={`d-flex flex-column  ${classes.mobileMenu}`}>
            <a
              href="https://docs.proptrading.fun"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-decoration-none ${classes.link}`}
            >
              Docs
            </a>
            <a href="/faq" className={`text-decoration-none ${classes.link}`}>
              Help
            </a>
            <a
              href="https://discord.com/invite/RmphJzRtke"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-decoration-none ${classes.link}`}
            >
              Join Discord
            </a>
            <div
              onClick={logout}
              className={`text-decoration-none ${classes.link} ${classes.buttonLink}`}
            >
              Logout
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
